<template>
  <div style="height: 40px; padding-top: 10px;">
  </div>
</template>

<script>
export default {
  props: [
    'numCorrect',
    'numTotal'
  ]
}
</script>
